/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Precheck_IgnoreInputs */

const en_audio_description_export_precheck_ignore = /** @type {(inputs: Audio_Description_Export_Precheck_IgnoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ignore`)
};

const fr_audio_description_export_precheck_ignore = /** @type {(inputs: Audio_Description_Export_Precheck_IgnoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ignorer`)
};

const de_audio_description_export_precheck_ignore = /** @type {(inputs: Audio_Description_Export_Precheck_IgnoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ignorieren`)
};

const it_audio_description_export_precheck_ignore = /** @type {(inputs: Audio_Description_Export_Precheck_IgnoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ignorare`)
};

const ru_audio_description_export_precheck_ignore = /** @type {(inputs: Audio_Description_Export_Precheck_IgnoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Игнорировать`)
};

const es_audio_description_export_precheck_ignore = /** @type {(inputs: Audio_Description_Export_Precheck_IgnoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ignorar`)
};

const zh_cn2_audio_description_export_precheck_ignore = /** @type {(inputs: Audio_Description_Export_Precheck_IgnoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`忽略`)
};

const ja_audio_description_export_precheck_ignore = /** @type {(inputs: Audio_Description_Export_Precheck_IgnoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無視する`)
};

const hi_audio_description_export_precheck_ignore = /** @type {(inputs: Audio_Description_Export_Precheck_IgnoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अनदेखा करना`)
};

const pt_pt2_audio_description_export_precheck_ignore = /** @type {(inputs: Audio_Description_Export_Precheck_IgnoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ignorar`)
};

/**
* | output |
* | --- |
* | "Ignore" |
*
* @param {Audio_Description_Export_Precheck_IgnoreInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_precheck_ignore = /** @type {((inputs?: Audio_Description_Export_Precheck_IgnoreInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Precheck_IgnoreInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_precheck_ignore(inputs)
	if (locale === "de") return de_audio_description_export_precheck_ignore(inputs)
	if (locale === "it") return it_audio_description_export_precheck_ignore(inputs)
	if (locale === "ru") return ru_audio_description_export_precheck_ignore(inputs)
	if (locale === "es") return es_audio_description_export_precheck_ignore(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_precheck_ignore(inputs)
	if (locale === "ja") return ja_audio_description_export_precheck_ignore(inputs)
	if (locale === "hi") return hi_audio_description_export_precheck_ignore(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_precheck_ignore(inputs)
	return en_audio_description_export_precheck_ignore(inputs)
});